import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=c3bb8804&scoped=true&"
import script from "@/views/Groups/Tabs/Messages.ts?vue&type=script&lang=ts&"
export * from "@/views/Groups/Tabs/Messages.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Groups/Tabs/messages.scss?vue&type=style&index=0&id=c3bb8804&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bb8804",
  null
  
)

export default component.exports